import { render, staticRenderFns } from "./ChiefDeptRatingUserDirectionsIndexRootView.vue?vue&type=template&id=6c127ee4"
import script from "./ChiefDeptRatingUserDirectionsIndexRootView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRatingUserDirectionsIndexRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports